import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import dayjs from 'dayjs'

interface MessageState {
  message: {
    id?: number
    title?: string
    message?: string
    date?: string
    type?: string
  }
}

export default function MessageDetail() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state as MessageState | null

  // 如果没有消息数据，返回列表页
  useEffect(() => {
    if (!state?.message) {
      navigate('/message', { replace: true })
    }
  }, [state, navigate])

  if (!state?.message) {
    return null
  }

  const { title, message, date } = state.message

  return (
    <PageLayout>
      <Header
        leftChildren={<Back />}
        centerChildren={<span className="text-base font-medium">{t('通知')}</span>}
      />

      <div className="px-5 py-6">
        {/* 标题 */}
        <h1 className="text-lg font-bold text-[#1D2129] mb-2">
          {title}
        </h1>

        {/* 日期 */}
        <div className="text-sm text-[#86909C] mb-6">
          {date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : ''}
        </div>

        {/* 内容 */}
        <div className="text-sm text-[#4E5969] leading-6 whitespace-pre-wrap">
          {message}
        </div>
      </div>
    </PageLayout>
  )
}

